import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";
import { FlexContainer } from "../../BaseComponents/Flex/FlexContainer";

export const BreadcrumbsLinkContainer = styled.div.attrs(({}) => ({}))`
	display: flex;
	align-items: center;
	background-color: ${({ bgColor }) => (bgColor ? bgColor : "")};
	margin: ${(margin) => margin};

	${media.lessThan(breakpoints.mobile)`
        display: ${({ show }) => (!show ? "none" : "")};

    `}
	${media.greaterThan(breakpoints.mobile)`
        font-weight: ${({ first }) => (first ? "bold" : "")};
	
    `}
`;
